const flexShrink = {
    name: "flex-shrink",
    path: "/flex-shrink",
    title: "flex-shrink",
    description: "Utilities for controlling how flex items shrink.",
    value: {
        "flex-shrink": {
          'shrink': "1",
          "shrink-<number>":"<number>"
        },
    },
    exampleData: [
        {
            "example": {
                "code": `
<div class="flex ...">
  <div class="h-14 w-14 flex-none ...">01</div>
  <div class="h-14 w-64 shrink ...">02</div>
  <div class="h-14 w-14 flex-none ...">03</div>
</div>
                `
            },
        },
        {
            "example": {
                "code": `
<div class="flex ...">
  <div class="h-16 flex-1 ...">01</div>
  <div class="h-16 w-32 shrink-0 ...">02</div>
  <div class="h-16 flex-1 ...">03</div>
</div>
                `
            },
        },
    ],
    htmlData: [
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">shrink  </code>
                 to allow a flex item to shrink if needed:
            </p>

            <div class="relative">
                <div class="absolute inset-0 z-0">
                    <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                </div>
                <div class="flex gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                    <div class="flex size-14 flex-none items-center justify-center rounded-lg bg-color-pink-300 p-4 dark:bg-color-pink-800 dark:text-color-pink-400">01</div>
                    <div class="flex h-14 w-64 shrink items-center justify-center rounded-lg bg-color-pink-500 p-4">02</div>
                    <div class="flex size-14 flex-none items-center justify-center rounded-lg bg-color-pink-300 p-4 dark:bg-color-pink-800 dark:text-color-pink-400">03</div>
                </div>
            </div>

            
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">shrink-<var>&lt;number&gt;</var></code>
                   to prevent a flex item from shrinking:
            </p>

             <div class="relative">
                <div class="absolute inset-0 z-0">
                    <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                </div>
                <div class="flex gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-300 p-4 dark:bg-color-pink-800 dark:text-color-pink-400">01</div>
                    <div class="flex h-14 w-32 md:w-64 shrink-0 items-center justify-center rounded-lg bg-color-pink-500 p-4">02</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-300 p-4 dark:bg-color-pink-800 dark:text-color-pink-400">03</div>
                </div>
            </div>
            `
        },
    ]
};

export default flexShrink;

<div className="sr-only shrink shrink-0 md:w-64">



</div>